import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const requiredEnv = (key, { optional = false } = {}) => {
  const value = import.meta.env?.[key];
  if (!value) {
    const message = `Missing required environment variable ${key}. Set it in your .env file before building.`;
    if (optional) {
      console.warn(message);
      return undefined;
    }
    throw new Error(message);
  }
  return value;
};

const firebaseConfig = {
  apiKey: requiredEnv('VITE_FIREBASE_API_KEY'),
  authDomain: requiredEnv('VITE_FIREBASE_AUTH_DOMAIN'),
  projectId: requiredEnv('VITE_FIREBASE_PROJECT_ID'),
  storageBucket: requiredEnv('VITE_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: requiredEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
  appId: requiredEnv('VITE_FIREBASE_APP_ID'),
  measurementId: requiredEnv('VITE_FIREBASE_MEASUREMENT_ID', { optional: true }),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
// Firebase Auth already uses LOCAL persistence by default, no need to set it

export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export { httpsCallable };

// Initialize Analytics lazily (only when needed, not on initial load)
let analytics = null;
export const getAnalyticsInstance = () => {
  if (typeof window === 'undefined' || !firebaseConfig.measurementId) {
    return null;
  }
  
  if (!analytics) {
    try {
      analytics = getAnalytics(app);
    } catch (error) {
      console.warn('Firebase Analytics initialization failed:', error);
    }
  }
  
  return analytics;
};

// Export analytics for backward compatibility (but it will be null initially)
export { analytics };

export default app;

